import { Layout } from "../components/layout/Layout";
import { JsonLd } from "../components/seo/JsonLd";
import { SEO } from "../components/seo/SEO";
import { websiteSchema } from "../components/seo/schema";
import { site } from "../data/site";

export function AboutPage() {
  return (
    <Layout>
      <SEO
        title={`About ${site.name}`}
        description={`Learn about ${site.name}, a lightweight wiki-style publishing project.`}
        canonical={`${site.url}/about`}
      />
      <JsonLd data={websiteSchema()} />
      <article className="page-article">
        <p className="eyebrow">About</p>
        <h1>About {site.name}</h1>
        <p>
          yawiki.org is a wiki-style blog built for structured articles, durable references, and practical editorial
          workflows. Its pages are prerendered so content and SEO schema are available in generated HTML.
        </p>
        <h2>Editorial approach</h2>
        <p>
          Articles are written in MDX, organized by categories and tags, and attributed to named authors. Future-dated
          posts remain private until their publish date arrives.
        </p>
      </article>
    </Layout>
  );
}
